<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">        
        <div class="backborder3" style="padding-bottom:2%">
        	<el-form :inline="true" class="demo-form-inline" size="small">
	            <el-form-item>
	                <el-date-picker v-model="query.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item>
	                <el-date-picker v-model="query.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item>
	                <el-button type="primary" icon="el-icon-search" @click="getcustomervisit">查询</el-button>
	                <!-- <el-button type="success" icon="el-icon-download" @click="getexportdata">导出</el-button> -->
	            </el-form-item>
        	</el-form>
        	<div v-loading="listLoading" style="float:left;width:100%;">
	        	<el-col :span="24">
	        		<el-col :span="6">
	        			<a class="cclick" @click="getAllcustomers">
	        			<div class="ccontent" :style="shadow1">
							<el-tooltip placement="top">
								<div slot="content">当前系统内所有客户数量</div>
	        					<span class="nums">{{lists.all}}</span>
							</el-tooltip>
	        				<span class="title">客户总数</span>
	        			</div>
	        			</a>
	        		</el-col>
	        		<el-col :span="6">
	        			<a class="cclick" @click="getaddcustomers">
	        			<div class="ccontent" :style="shadow2">
							<el-tooltip placement="top">
								<div slot="content">指定时间内录入系统的客户数</div>
	        					<span class="nums">{{lists.add}}</span>
							</el-tooltip>
	        				<span class="title">新增客户</span>
	        			</div>
	        			</a>
	        		</el-col>
	        		<el-col :span="6">
	        			<a class="cclick" @click="getvisit">
	        			<div class="ccontent" :style="shadow3">
							<el-tooltip placement="top">
								<div slot="content">指定时间签到的跑店记录</div>
	        					<span class="nums">{{lists.runs}}</span>
							</el-tooltip>
	        				<span class="title">拜访客户</span>
	        			</div>
	        			</a>
	        		</el-col>
	        		<el-col :span="6">
	        			<a class="cclick" @click="getsells">
	        			<div class="ccontent" :style="shadow4">
							<el-tooltip placement="top">
								<div slot="content">指定时间内销售出库单（状态：已完成）的客户个数</div>
	        					<span class="nums">{{lists.sells}}</span>
							</el-tooltip>
	        				<span class="title">成交客户</span>
	        			</div>
	        			</a>
	        		</el-col>
	        	</el-col>
        	</div>
        </div>
        
        <!------------拜访统计-------------->
        <div class="backborder3" style="margin:15px 0 0 0;padding:1% 1% 1% 1%;">
	        <el-form :inline="true" class="demo-form-inline" size="small">
	            <el-form-item>
	                <el-date-picker v-model="visitquery.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item>
	                <el-date-picker v-model="visitquery.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item size="small" style="width:12%">
	    			<el-select v-model="visitquery.seller" clearable filterable placeholder="请选销售员" @change="visitisselect=true" style="width:100%">
						<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
    			</el-form-item>
	            <el-form-item>
	                <el-button type="primary" icon="el-icon-search" @click="getvisitstat">查询</el-button>
	            </el-form-item>
	        </el-form>
			<div style="float:left;width:100%" v-loading="visitLoading">
        		<table border="0" cellspacing="0" cellpadding="0" class="tableshow">
		    		<tr>
			      		<th align="center">业务员</th>
			      	  	<th align="center">客户数量</th>
			      	  	<th align="center">拜访合计</th>
			      	  	<th align="center">新增客户</th>
			      	  	<th align="center">拜访老客户</th>
			      	  	<th align="center">成交客户</th>
			      	  	<th align="center" v-for="(item,index) in visitliststitle">{{item}}</th>
		      		</tr>
			      	<tr v-for="(item,index) in visitlists">
			      	  	<td align="center">{{item.name}}</td>
			      	  	<td align="center">{{item.all}}</td>
			      	  	<td align="center"><a href="javascript:void(0)" @click="getrundetail(item.id)" class="vt">{{item.total}}</a></td>
			      	  	<td align="center">{{item.add}}</td>
			      	  	<td align="center">{{item.old}}</td>
			      	  	<td align="center">{{item.sell}}</td>
			      	  	<td align="center" v-for="(e,i) in item.levs">{{e.all}}</td>
			      	</tr>
		   	   </table>
		    </div>
        </div>
        
        <!---------客户统计------------>
        <div class="backborder3" style="margin:15px 0 2% 0;padding:1% 1% 1% 1%;">
	        <el-form :inline="true" class="demo-form-inline" size="small">
	            <el-form-item>
	                <el-date-picker v-model="customerquery.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item>
	                <el-date-picker v-model="customerquery.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
	            </el-form-item>
	            <el-form-item>
	                <el-button type="primary" icon="el-icon-search" @click="getcustano">查询</el-button>
	            </el-form-item>
	        </el-form>
	        <div class="brand" style="float:left;width:100%">
        		<IEcharts :option="brand" :loading="custnaoLoading"/>
		    </div>
        </div>
        
        <el-dialog title="拜访信息详情" :visible.sync="detailDialog" width="80%" top="5vh">
	    	<el-table :data="detailists" style="width: 100%" v-loading="detailLoading">	    		
		        <el-table-column label="客户名称" prop="customername"></el-table-column>
		        <el-table-column label="客户等级" prop="levelname" align="center" width="120"></el-table-column>
		        <el-table-column label="跟进人" prop="clerkname" align="center" width="120"></el-table-column>
		        <el-table-column label="地址" prop="address" align="left" width="250"></el-table-column>	
		        <el-table-column label="意向" prop="note" align="left" width="250"></el-table-column>
		        <el-table-column label="签到时间" prop="inputtime" align="center" width="160"></el-table-column>	 	      	      
	        </el-table>
	        <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="runPageSizeChange"
		          @current-change="runPageCurrentChange"
		          :current-page="rundetailquery.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="rundetailquery.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="detail_total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>	                
	    </el-dialog>   
	    
    </div>
    </transition>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Report/index",
      actionauth:[],
      transitionshow:true,
      query: {
      	  act:'getCustomervisit',
      	  token:this.$cookies.get('token'),
      	  start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
      	  end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
      },
      listLoading:false,
      lists:[],
	  visitquery: {
	  	  act:'getcustomervisitsexportnew',
      	  token:this.$cookies.get('token'),
      	  start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
      	  end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
      	  seller:'',
	  },
	  customerquery: {
	  	  act:'getcustnewandolds',
      	  token:this.$cookies.get('token'),
      	  start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
      	  end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	  },
	  custnaoLoading:false,
	  custnaolists:[],
	  visitisselect:false,
	  sellerLists:[],
	  visitLoading:false,
	  visitlists:[],
	  visitliststitle:[],
	  detailDialog:false,
	  detailLoading:false,
	  detailists:[],
	  detail_total_rows:0,
	  rundetailquery: {
	  	  act:'rundetail',
	  	  token:this.$cookies.get('token'),
	  	  id:'',
	  	  start:'',
	  	  end:'',
	  	  p:1,
	  	  rollpage:10,
	  },
	  
	  brand: {
          legend: {
			 data:['拜访客户','新增客户']
		  },
		  xAxis: {			  
			  type: 'category', // 还有其他的type，可以去官网喵两眼哦
			  data: [], // x轴数据
			  name: '', //x轴名称
			  nameTextStyle: { //x轴名称样式
			    fontWeight: 600,
			    fontSize: 18,
			  }		  
		  },
		  yAxis: {
			  type: 'value',
			  name: '', //y轴名称
			  nameTextStyle: { //y轴名称样式
			    fontWeight: 600,
			    fontSize: 18
			  }    
		  },
		  tooltip: {
			  trigger: 'axis' //axis item none三个值
		  },
		  
		  series: [
			  {
			    name: '拜访客户',
			    data: [],
			    type: 'line',
			    itemStyle : {
					normal : {
						color:'#409EFF',
						lineStyle:{color:'#409EFF'}
					}
				},
			  },
			  {
			    name: '新增客户',
			    data: [],
			    type: 'line',
			    itemStyle : {
					normal : {
						color:'#67C23A',
						lineStyle:{color:'#67C23A'}
					}
				},
			  }
		  ]
		  
      },
	  
    }
  },
  
  components: {
    IEcharts
  },
  
  mounted(){
    this.getactionauth();
    this.getSeller();
    this.getcustomervisit();
    this.getvisitstat();
    this.getcustano();
  },
  methods:{
  
    /** 获取功能权限  **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取客户拜访统计列表 **/
    getcustomervisit() {    
    	this.listLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.listLoading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.listLoading=false;
            }
        }).catch((res) => {
            this.listLoading=false;
        });
    },
    
    /** 获取拜访客户统计数据 **/
    getvisitstat() {
    	this.visitLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.visitquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.visitLoading=false;
            }else{
            	var _this=this;
            	this.visitliststitle=[];
                this.visitlists = JSON.parse(Base64.decode(res.data.Data));
                this.visitlists[0].levs.forEach(function(e,index) {
                	_this.visitliststitle.push(e.name);
                });
                this.visitLoading=false;
            }
        }).catch((res) => {
            this.visitLoading=false;
        });
    },
    
    /** 获取拜访合计详情信息 **/
    getrundetail(id) {
    	this.rundetailquery.id=id;
    	this.rundetailquery.start=this.visitquery.start;
    	this.rundetailquery.end=this.visitquery.end;
    	this.rundetailquery.p=1;
    	this.rundetailquery.rollpage=10;
    	this.detailDialog=true;
    	this.getrundetaillists();
    },
    
    getrundetaillists() {
    	this.detailLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.rundetailquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.detailLoading=false;
            }else{
            	var _this=this;
                this.detailists = JSON.parse(Base64.decode(res.data.Data));
                this.detail_total_rows=parseInt(res.data.count);
                this.detailLoading=false;
            }
        }).catch((res) => {
            this.detailLoading=false;
        });
    },
    
    runPageSizeChange(val) {
  	   	this.rundetailquery.rollpage = val;
        this.getrundetaillists();
  	},
  	runPageCurrentChange(val) {
  	   	this.rundetailquery.p = val;
        this.getrundetaillists();
  	},
    
    //获取客户统计信息
    getcustano() {
    	this.custnaoLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.customerquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.custnaoLoading=false;
            }else{
            	var _this=this;
                this.custnaolists = JSON.parse(Base64.decode(res.data.Data));
                this.brand.xAxis.data=this.custnaolists.time; //时间段
                this.brand.series[0].data=this.custnaolists.sign; //拜访客户
                this.brand.series[1].data=this.custnaolists.customer; //新增客户                                
                this.custnaoLoading=false;
            }
        }).catch((res) => {
            this.custnaoLoading=false;
        });
    },
    
    /** 点击客户总数 **/
    getAllcustomers() {
    	this.$emit('listenchild',{name:'客户管理',url:'Customer'});
    },
    
    /** 获取新增客户总数 **/
    getaddcustomers() {
    	
    },
    
    /** 获取拜访客户信息 **/
    getvisit() {
    	
    },
    
    /** 成交客户信息 **/
    getsells() {
    	 	
    },

    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.ccontent {width:70%;height:100px;margin:3% 0 3% 3%;border:1px solid rgba(221,221,221,.6);border-radius:6px;background:rgba(221,221,221,.4);transition:all .3s}
.ccontent:hover {box-shadow:3px 3px 10px #999999}
.nums,.title {float:left;width:100%;text-align:center;color:#333336}
.nums {font-size:22px;padding:20px 0 10px 0;font-weight:bold}
.title {padding:0 0 10px 0;font-size:14px}
.cclick {cursor: pointer}
.tableshow {width:100%;border:1px solid #ebeef5;color:#606266;font-size:14px;border-collapse: collapse;}
.tableshow tr th {background:rgb(221, 221, 221,.4);font-weight:normal;font-size:13px;font-weight:540}
.tableshow tr th, .tableshow tr td { border:1px solid #ebeef5;padding:15px 0}
.tableshow tr td {line-height:23px;padding:10px 0;font-size:13px}
.vt {text-decoration:underline;color:#606266}
.brand {width:100%;height:400px;margin-top:10px}
</style>


// WEBPACK FOOTER //
// src/components/report/Customervisit.vue